import React from 'react';
import { connect } from 'redux-bundler-react';
import PluginRegion from '../utils/plugin-region';
import PrimaryPanel from './primary-panel';
import BasicToolbar from './basic-toolbar';

class LeftSidebar extends React.Component {
  render() {
    const { theme, componentsLeftSidebarBottom, componentsLeftSidebarTop } = this.props;

    return (
      <div className={'sidebar sidebar-left ' + theme}>

        <PluginRegion
          className="sidebar-buttons-top"
          components={componentsLeftSidebarTop}
          styleOverride={{width:'100%'}}
        />

        <PluginRegion
          className="sidebar-buttons-bottom"
          components={componentsLeftSidebarBottom}
          styleOverride={{width:'100%'}}
        />

        <PrimaryPanel />

        <BasicToolbar />

      </div>
    )
  }
}

export default connect(
  'selectTheme',
  'selectComponentsLeftSidebarTop',
  'selectComponentsLeftSidebarBottom',
  LeftSidebar
)